import React from 'react';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import 'react-loading-skeleton/dist/skeleton.css';
import GlobalFeedback from './Components/Common/GlobalFeedback'; // ⬅️ ADD THIS

import PrivateRoute from './Pages/Auth/PrivateRoute'; // 👈 import it
// Public Pages
import Homepage from './Pages/Public/Homepage';
import SignIn from './Pages/Auth/SignIn';
import SignUp from './Pages/Auth/SignUp';
import OnboardingForm from './Pages/Auth/OnboardingForm';
import ForgotPassword from './Pages/Auth/ForgotPassword';
import NotFound from './Pages/Public/NotFound'

// Dashboard Layout & Pages
import DashboardLayout from './Pages/Dashboard/layout/DashboardLayout';
import Dashboard from './Pages/Dashboard/widgets/Overview/Overview';
import Projects from './Pages/Dashboard/Projects'; // ✅ Create this to list cards
import CreateProject from './Pages/Dashboard/widgets/CreateProject';
import ProjectDetails from './Pages/Dashboard/widgets/ProjectView/ProjectDetails';

// Profile 
import ProfilePage from './Pages/Dashboard/widgets/Profile/ProfilePage'
import ProfileTab from './Pages/Dashboard/widgets/Profile/Tabs/ProfileTab'
import SettingsTab from './Pages/Dashboard/widgets/Profile/Tabs/SettingsTab'
import BillingTab from './Pages/Dashboard/widgets/Profile/Tabs/BillingTab'

import ExpenseReportPrint from './Pages/Dashboard/widgets/ProjectView/Tabs/Reports/ExpenseReportPrint';
import ExpenseReportPreview from './Pages/Dashboard/widgets/ProjectView/Tabs/Reports/ExpenseReportPreview';
import MaterialReportPreview from './Pages/Dashboard/widgets/ProjectView/Tabs/Reports/MaterialReportPreview';
import LaborReportPreview from './Pages/Dashboard/widgets/ProjectView/Tabs/Reports/LaborReportPreview';
import ProjectReportPreview from './Pages/Dashboard/widgets/ProjectView/Tabs/Reports/ProjectReportPreview';

// adjust relative path as per your structure



// Other
import HowToUse from './Pages/Dashboard/widgets/Other/HowToUse'
import WhatsNew from './Pages/Dashboard/widgets/Other/WhatsNew';
import ContactUs from './Pages/Dashboard/widgets/Other/ContactUs';
import AboutUs from './Pages/Dashboard/widgets/Other/AboutUs';

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Public Routes */}
        <Route path="/" element={<Homepage />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/onboarding" element={<OnboardingForm />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />




        {/* Dashboard Layout + Nested Routes */}
        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="projects" element={<Projects />} />
          <Route path="create" element={<CreateProject />} />
          <Route path="project/:projectId" element={<ProjectDetails />} />
          <Route path="profile" element={<ProfilePage />}>
            <Route index element={<ProfileTab />} />
            <Route path="settings" element={<SettingsTab />} />
            <Route path="billing" element={<BillingTab />} />
            {/* <Route path="plugins" element={<PluginsTab />} /> */}
          </Route>
          <Route path="How-to-use" element={<HowToUse />} />
          <Route path="Whats-new" element={<WhatsNew />} />
          <Route path="Contact-us" element={<ContactUs />} />
          <Route path="about" element={<AboutUs />} />
          {/* 👇 NEW preview route */}
          <Route path="expense-report-preview" element={<ExpenseReportPreview />} />
          <Route path="material-report-preview" element={<MaterialReportPreview />} />
          <Route path="labor-report-preview" element={<LaborReportPreview />} />
          <Route
            path="/dashboard/project-report-preview"
            element={
              <PrivateRoute>
                <ProjectReportPreview />
              </PrivateRoute>
            }
          />

        </Route>
        <Route path="*" element={<NotFound />} />

      </Routes>
    </AnimatePresence>
  );
};

const App = () => {
  return (

    <Router>
      <ToastContainer position="bottom-right" autoClose={3000} />


      {/* New global backend-driven popup */}
      <GlobalFeedback />


      <AnimatedRoutes />
    </Router>

  );
};

export default App;
